<template>
  <div class="footer">
    <div class="content">
      <div>
        地址：北京市西城区广安门内大街北线阁5号中国中医科学院广安门医院
        电话：010-88001229
      </div>
      <!-- <div>技术支持：铭成医疗</div> -->
    </div>
    <div class="content">
      <div>
        版权所有：中国中医科学院广安门医院
        <a href="https://beian.miit.gov.cn/" target="_blank"
          >京ICP备2023035728号</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlobalFooter',
  data() {
    return {}
  },
}
</script>

<style lang="less" scoped>
.footer {
  width: 100%;
  height: 100px;
  background: url('../../src/assets/images/menuBac.png') no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
}
.content {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #fff5ea;
  a {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #fff5ea;
  }
}
</style>
